const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');
// 结算汇总
const pdPeriodList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/productionCenter/pdPeriod/list.vue')),
    'pdPeriodList'
  );
const pdPeriodAdd = (r) =>
  require.ensure([], () => r(require('@/pages/productionCenter/pdPeriod/add.vue')), 'pdPeriodAdd');
const productionRouter = {
  path: '/production',
  component: index,
  children: [
    {
      path: 'pdPeriodList',
      name: 'pdPeriodList',
      component: pdPeriodList,
      meta: {
        keepAlive: true,
        title: '账期管理',
      },
    },
    {
      path: 'pdPeriodAdd',
      name: 'pdPeriodAdd',
      component: pdPeriodAdd,
      meta: {
        keepAlive: true,
        title: '账期新增',
      },
    },
  ],
};
export default productionRouter;
